define(function (require) {
	const Marionette = require('backbone.marionette');
	const tpl = require('civicsViews/page_view/t_itv_page.hbs');
	const MAX_PAGES = 5;

	return Marionette.ItemView.extend({
		template: tpl,
		ui: {
			goPage: '.page-number',
			nextButton: '.btn-next',
			previousButton: '.btn-prev',
			lastButton: '.btn-last',
			firstButton: '.btn-first'
		},
		events: {
			'click @ui.goPage': 'goPage',
			'click @ui.nextButton': 'goNext',
			'click @ui.previousButton': 'goPrevious',
			'click @ui.lastButton': 'goLast',
			'click @ui.firstButton': 'goFirst',
		},
		initialize: function (options) {
			this.total = (options.total) ? options.total : 1;
			this.initPage = options.initPage; // Using a separate variable for page from Hash to not interfere with other paging code on page navigation
			this.pageCallback = options.pageCallback;
			this.goToLastPageCallback = options.goToLastPageCallback;
			this.paginationId = options.paginationId ? options.paginationId : "pageview-pagination";
			this.resetDisplay();
		},
		setTotal: function (total) {
			if (total !== this.total) {
				this.total = total;
				this.updateDisplay();
			}
		},
		//this should not be here. This should be a callback provided in the constructor.
		clearMap: function () {
			$('.ol-popup-closer').trigger("click");
		},
		pageReturn: function () {
			// Execute callback if provided, otherwise null
			const cbReturn = this.pageCallback ? this.pageCallback(this.page) : null;
			// $.when normalizes sync values, Promises, and jQuery Deferreds
			$.when(cbReturn).done(() => {
				this.updateDisplay();
			});
		},
		updateToPage: function(pageNum) {
			this.page = pageNum;
			this.pageReturn();
		},
		goNext: function () {
			this.page++;
			this.pageReturn();
		},
		goPrevious: function () {
			this.page--;
			this.pageReturn();
		},
		goPage: function (e) {
			e.preventDefault();
			this.page = parseInt($(e.currentTarget).data('page-number'), 10);
			this.pageReturn();
		},
		goFirst: function (e) {
			e.preventDefault();
			this.page = 1;
			this.pageReturn();
		},
		goLast: function () {
			if (this.lastPage) {
				this.page = this.lastPage;
				this.pageReturn();
			} else {
				//fetch the total page count, store it, then
				this.goToLastPageCallback();
			}
		},
		updateDisplay: function () {
			this.display.pages = [];
			this.clearMap();
			//iterate over the three possible numbers to be displayed, page before current, current, and page after current
			//we will always display 3 positions, even if the previous page and/or the next page is blank
			for (var i = this.page - 1; i <= this.page + 1; i++) {
				var pageData = {
					id: i,
					active:(i == this.page)
				};
				//if we're on the first or the last page or both, show a blank spot for the previous/next page
				if (i < 1 || i>this.currentMax) {
					pageData.id = null;
				}

				this.display.pages.push(pageData);
			}

			this.display.arrow.left.inactive = (this.page == 1);
			this.display.arrow.right.inactive = (this.page == this.currentMax);
			this.render();
		},
		updateCurrentMax:function(newMax){
			if (newMax > this.currentMax) {
				this.currentMax = newMax;
			}
			this.updateDisplay();
		},
		resetDisplay: function () {
			this.page = this.initPage ? this.initPage : 1;
			this.initPage = false;
			this.currentMax = this.page;
			this.display = {
				arrow: {
					left: {
					},
					right: {
					},
				},
				pages: [],
			};
			this.updateDisplay();
		},
		templateHelpers: function () {
			return {
				display: this.display,
				page: this.page,
				initPage: this.initPage,
				total: this.total,
				paginationId: this.paginationId,
				paginationLabel: i18n.t('CIVICS.COMMON.PAGINATION'),
				scrText: i18n.t('CIVICS.COMMON.GO_TO_PAGE'),
				pageOf: i18n.t('CIVICS.COMMON.PAGINATION_CUR_OF_TOT', { cur: this.page, tot: this.total }),
				goToPreviousPage: i18n.t('CIVICS.COMMON.PREVIOUS_PAGE'),
				goToFirstPage: i18n.t('CIVICS.COMMON.FIRST_PAGE'),
				goToLastPage: i18n.t('CIVICS.COMMON.LAST_PAGE'),
				goToNextPage: i18n.t('CIVICS.COMMON.NEXT_PAGE'),
				goToPage: function (num) {
					return i18n.t('CIVICS.COMMON.GO_TO_PAGE') + ' ' + num;
				}
			};
		},
	});
});
